// app/javascript/components/shared/ui/IconButton.js
//
// Square / circular icon-only button. Different size scale from Button — these
// sit inside table rows, modals, and toolbars.
import React, { forwardRef } from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"

export const iconButtonVariants = cva(
  "inline-grid place-items-center rounded-md focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed",
  {
    variants: {
      tone: {
        neutral: "bg-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-900",
        danger:  "bg-transparent text-slate-500 hover:bg-rose-50 hover:text-rose-600",
        // Hover-revealed variant used inside grid rows — the parent must have
        // `group` for the hover handoff. Caller can pin it visible by
        // composing additional classes through className.
        "row":   "bg-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-900 opacity-0 group-hover:opacity-100",
      },
      size: {
        xs: "w-[22px] h-[22px] text-[10px]",
        sm: "w-6 h-6 text-[12px]",
        md: "w-8 h-8 text-[13px]",
        lg: "w-9 h-9 text-sm",
      },
    },
    defaultVariants: { tone: "neutral", size: "md" },
  }
)

const IconButton = forwardRef(({ tone, size, className, type = "button", ...props }, ref) => (
  <button
    ref={ref}
    type={type}
    className={clsx(iconButtonVariants({ tone, size }), className)}
    {...props}
  />
))
IconButton.displayName = "IconButton"

export default IconButton
